import React from 'react';

const Option = function({name,value,placeholder,selected}) {
    return (
        <option value={value}>{name}</option>
    );
}

export default Option;
